import axios from 'axios';

// createApiClient now takes the accessToken directly
const createApiClient = (accessToken) => {
  const baseURL = "https://api.wxcc-us1.cisco.com/"; // Correct base URL

  // Create base configuration for axios
  const axiosInstance = axios.create({
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      // Set the Authorization header globally for this instance
      'Authorization': `Bearer ${accessToken}` 
    }
  });

  // Add request interceptor for logging or manipulation if needed
  axiosInstance.interceptors.request.use(
    config => {
      console.log("Axios Request:", config.method.toUpperCase(), config.baseURL + config.url, config.data || config.params || '');
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // Add response interceptor for handling common response patterns
  axiosInstance.interceptors.response.use(
    response => {
      // Return the full response object from Axios
      return response;
    },
    error => {
      console.error(`API request failed: ${error.message}`);
      
      // Enhanced error handling with response details when available
      if (error.response) {
        console.error(`Status: ${error.response.status}`);
        console.error(`Response data:`, error.response.data); // Access error data more precisely
        console.error(`Response headers:`, error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.error(`No response received:`, error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error(`Error setting up request:`, error.message);
      }
      
      return Promise.reject(error);
    }
  );

  // Return the configured axiosInstance directly, which has .get, .post, etc. methods
  return axiosInstance;
};

export { createApiClient };
